import { raise } from '@vy/utils';
import { createContext, useContext } from 'react';
import type { PlanCreationPlanPreview } from '../../../../../contexts/create-plan-context/CreatePlanProvider/create-plan-provider-types/plan-creation-plan-preview';
import type { UseVyStepper } from '../../../../../hooks/use-vy-stepper';
import type { CreateInvoiceTab } from './create-invoice-context-types/create-invoice-tab';
import type { InvoiceCreationStep } from './create-invoice-context-types/invoice-creation-step';

export type CreateInvoiceContextProps = {
  createInvoiceTab: CreateInvoiceTab;
  setCreateInvoiceTab: (tab: CreateInvoiceTab) => void;
  invoiceCreationStepper: UseVyStepper<InvoiceCreationStep>;
  planPreview: PlanCreationPlanPreview;
};

export const CreateInvoiceContext = createContext<CreateInvoiceContextProps | undefined>(undefined);

export function useCreateInvoiceContext() {
  const createInvoiceContext = useContext<CreateInvoiceContextProps | undefined>(CreateInvoiceContext);

  if (!createInvoiceContext) {
    raise('useCreateInvoiceContext must be used within a CreateInvoiceContextProvider');
  }

  return createInvoiceContext;
}
